import { useParams } from "react-router-dom";

export const useDecodedParams = () => {
  const params = useParams();
  let decodedParams = {};
  for (let key in params) {
    decodedParams[key] = decodeURIComponent(params[key]);
  }
  return decodedParams;
};
